module.exports = __webpack_public_path__ + "img/pt.6b5102be.png";